import { path } from '~/utils/media';
import { constantCreator } from '~/utils/constantsCreator';
import { GalleryName } from '~/utils/gallery';

// const constant = constantCreator.defineAction('gallery').defineAction;
const constant = constantCreator('gallery');
const GOTO = constant('GOTO');
const NEXT = constant('NEXT');
const OPEN_AND_GOTO = constant('OPEN_AND_GOTO');
const PREV = constant('PREV');
const CLOSE = constant('CLOSE');

const initialState = {
  galleryName: null,
  activeIndex: 0,
  items: [],
  defaultAlt: ''
};

const getGelleryItems = (srcImages, srcVideo) => {
  let items = [];
  if (srcVideo) {
    items = [{
      index: 0,
      caption: '',
      thumbnailStyle: {
        backgroundImage: `url(https://img.youtube.com/vi/${srcVideo}/0.jpg)`,
      },
      style: {
        backgroundImage: `url(https://img.youtube.com/vi/${srcVideo}/0.jpg)`,
      },
      url: `https://img.youtube.com/vi/${srcVideo}/0.jpg`,
      video: `https://www.youtube.com/embed/${srcVideo}?autoplay=1`,
    }];
  }
  if (srcImages) {
    const images = srcImages.map((image, index) => {
      return {
        ...image,
        index: srcVideo ? index + 1 : index,
        style: path(image.image, 'gallery', true),
        thumbnailStyle: path(image.image, 'thumbnail', true),
        url: path(image.image, 'mobileGallery'),
      };
    });
    items = [...items, ...images];
  }
  return items;
};

export default function gallery(state = initialState, action = {}) {
  switch (action.type) {
    case GOTO:
      return {
        ...state,
        activeIndex: action.index,
      };
    case NEXT:
      return {
        ...state,
        activeIndex: state.activeIndex + 1 >= state.items.length
          ? 0
          : state.activeIndex + 1,
      };
    case OPEN_AND_GOTO:
      return {
        ...state,
        galleryName: action.name || GalleryName.DEFAULT,
        items: getGelleryItems(action.images),
        defaultAlt: action.defaultAlt,
        activeIndex: action.index,
      };
    case PREV:
      return {
        ...state,
        activeIndex: state.activeIndex - 1 < 0
          ? state.items.length - 1
          : state.activeIndex - 1,
      };
    case CLOSE:
      return {
        ...initialState,
        activeIndex: state.activeIndex
      };
    default:
      return state;
  }
}

export const actions = {
  goTo: index => ({
    type: GOTO,
    index,
  }),
  next: () => ({
    type: NEXT,
  }),
  openAndGoTo: (index = 0, name, galleryProps) => ({
    type: OPEN_AND_GOTO,
    index,
    name,
    video: galleryProps.video,
    images: galleryProps.images,
    defaultAlt: galleryProps.defaultAlt
  }),
  prev: () => ({
    type: PREV,
  }),
  closeGallery: () => ({
    type: CLOSE
  })
};
